module.exports = __webpack_public_path__ + "static/media/datagrid-feature-05.aa1f3985.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/datagrid-feature-05.jpg
// module id = 1496
// module chunks = 0